// Microsoft Clarity loader + consent helpers.
// Clarity is only injected AFTER the user opts in, so no tracking cookies are
// set before consent.

const CONSENT_KEY = "fp_cookie_consent"; // "accepted" | "declined"
let loaded = false;

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* ignore */
  }
}

export function initClarity() {
  const id = process.env.REACT_APP_CLARITY_ID;
  if (!id || loaded || typeof window === "undefined") return;
  loaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
}

// Best-effort revoke for users who accepted then later declined.
export function revokeClarity() {
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity("consent", false);
    }
  } catch {
    /* ignore */
  }
}
